var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "brdr-none bg-cl-transparent" }, [
      _c("i", { staticClass: "material-icons h6" }, [_vm._v("delete")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }